import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import template1 from "../../assets/resume1.svg";
import template2 from "../../assets/resume2.svg";
import template3 from "../../assets/resume3.svg";
import template4 from "../../assets/resume4.svg";
import template5 from "../../assets/resume5.svg";
import template6 from "../../assets/resume6.svg";
import template7 from "../../assets/resume7.svg";
import template8 from "../../assets/resume8.jpeg";

import bannerImg from "../../assets/cvtemplatebanner.png";

export default function ResumeTemplates() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const templates = [
    { id: 1, img: template1, name: "Professional" },
    { id: 2, img: template2, name: "Modern" },
    { id: 3, img: template3, name: "Minimal" },
    { id: 4, img: template4, name: "Creative" },
    { id: 5, img: template5, name: "Simple" },
    { id: 6, img: template6, name: "Classic" },
    { id: 7, img: template7, name: "Elegant" },
    { id: 8, img: template8, name: "Bold" },
  ];

  const handleTemplateSelect = (templateId) => {
    navigate(`/resume-editor?template=${templateId}`);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto mt-20 sm:mt-20">

        {/* Banner Section */}
        <section className="w-full bg-[#97C0FF] bg-opacity-30">
          <div className="max-w-6xl mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 py-8 md:py-10">

              {/* Left Content */}
              <div className="flex-1">
                <h1 className="text-2xl md:text-3xl font-bold text-gray-700 mb-2">
                  Free Resume Templates
                </h1>
                <p className="text-sm md:text-base font-medium text-gray-500 max-w-xl">
                  Choose from professionally designed, ATS-friendly resume templates.
                  Create a resume that helps you get hired faster.
                </p>
              </div>

              {/* Right Image */}
              <div className="flex-1 flex justify-center md:justify-end">
                <img
                  src={bannerImg}
                  alt="Resume Illustration"
                  className="max-h-[180px] md:max-h-[220px] w-auto object-contain"
                />
              </div>

            </div>
          </div>
        </section>

        {/* Templates Grid */}
        <section className="max-w-6xl mx-auto px-4 py-12 md:py-14">
          <h2 className="text-lg md:text-xl font-semibold text-gray-700 mb-6">
            Resume Templates
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {templates.map((template) => (
              <div
                key={template.id}
                onClick={() => handleTemplateSelect(template.id)}
                className="rounded-xl border border-gray-200 overflow-hidden
                  hover:shadow-lg transition-all duration-300 cursor-pointer bg-white
                  hover:-translate-y-1"
              >
                <img
                  src={template.img}
                  alt={template.name}
                  className="w-full h-[420px] object-contain bg-gray-50"
                />

                <div className="p-3 text-center">
                  <p className="text-sm font-medium text-gray-600">
                    {template.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

      </div>
    </div>
  );
}
